export type HreflangLink = {
  hrefLang: string;
  href: string;
};

type HreflangAlternatesInput = {
  origin: string;
  path: string;
  locales?: string[];
  xDefaultLocale?: string;
};

export const hreflangAlternates = ({
  origin,
  path,
  locales,
  xDefaultLocale,
}: HreflangAlternatesInput): HreflangLink[] => {
  const langs = [...new Set(locales ?? ['en', 'ru'])];
  const links = langs.map((lang) => ({
    hrefLang: lang,
    href: `${origin}/${lang}${path}`,
  }));
  const defaultLang =
    xDefaultLocale ??
    (locales ? (langs.includes('ru') ? 'ru' : langs[0]) : 'en');

  if (defaultLang && langs.includes(defaultLang)) {
    links.push({
      hrefLang: 'x-default',
      href: `${origin}/${defaultLang}${path}`,
    });
  }

  return links;
};
